import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/app/app";
import { initSentry } from "@/lib/sentry/client";
import "@/styles/global.css";

initSentry();

const container = document.getElementById("root");
if (!container) {
  throw new Error("[main] #root container not found");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
